import Reflux from 'reflux';
import HoverAction from '../action/hoverAction';

export default Reflux.createStore({
  listenables: HoverAction,
  onPushHoverData: function(post) {
    this.trigger(post);
  },
});



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/store/hoverStore.js